
import { NavBar } from "@/components/NavBar"
import './MAnalysis.scss'
import { useRecoilState, useRecoilValue } from "recoil"
import ErrorPage from "@/components/Error"
import { useNavigate } from "react-router-dom"
import { QuizAnswerComponent, QuizBootom, QuizNavigateComponent, queryQuestionState } from "./MQuiz"
import { quizState } from "@/models/quizState"
import produce from 'immer';
import { ImageViewer } from "antd-mobile"
import { paperState } from "./MPaper"
import { QuestionModel } from "@/models/typing"
import { isMobile } from "@/utils/util"





export const AnalysisComponent = ({ question }: { question: QuestionModel }) => {

    const navigate = useNavigate()

    const paper = useRecoilValue(paperState)

    const [quiz, setQuiz] = useRecoilState(quizState)

    const errorQuestion = paper.error_question_list.find((item) => {
        return question.question_id === item.question_id
    })

    if (errorQuestion === undefined) {
        return <ErrorPage message="错误题目不存在" onRetry={() => { navigate(-1) }} />
    }


    let errorAnswer = ''
    let correctAnswer = ''

    errorQuestion.submit_answer.forEach((item) => {
        let index = question.answer_list.findIndex((answer) => {
            return answer.answer_id == item
        })
        if (index >= 0) {
            errorAnswer += ['A ', 'B ', 'C ', 'D '][index]
        }
    })

    errorQuestion.correct_answer.forEach((item) => {
        let index = question.answer_list.findIndex((answer) => {
            return answer.answer_id == item
        })

        if (index >= 0) {
            correctAnswer += ['A ', 'B ', 'C ', 'D '][index]
        }
    })

    return (
        <div className={isMobile() ? 'mobile-analysis' : 'desktop-analysis'}>
            <div className="analysis-view">
                <div className="analysis-view-board"></div>
                <div className="analysis-view-container">
                    <div className="analysis-view-answer">
                        <p>{`您的答案:${errorAnswer}`}</p>
                        <p>{`正确答案:${correctAnswer}`}</p>
                    </div>
                    <div className="analysis-view-divider"></div>
                    <p className="analysis-view-remark">{`${errorQuestion.analysis_remark}`}</p>
                    {
                        errorQuestion.analysis_img && (
                            <img className="analysis-view-image"
                                src={errorQuestion.analysis_img}
                                onClick={(event) => {
                                    event.stopPropagation()
                                    setQuiz(produce(quiz, (draftState) => {
                                        draftState.image = errorQuestion.analysis_img
                                        draftState.visible = true
                                    }))
                                }}
                            />
                        )
                    }
                </div>
            </div>
        </div>
    )
}



export const MobileAnalysis = () => {

    const navigate = useNavigate()

    const [quiz, setQuiz] = useRecoilState(quizState)

    const paper = useRecoilValue(paperState)

    const question = useRecoilValue(queryQuestionState)


    if (question === undefined) {
        return <ErrorPage message="题目不存在" onRetry={() => { navigate(-1) }} />
    }

    const errorQuestion = paper.error_question_list.find((item) => {
        return question.question_id === item.question_id
    })

    if (errorQuestion === undefined) {
        return <ErrorPage message="题目不存在" onRetry={() => { navigate(-1) }} />
    }

    return (
        <div className="mobile-quiz">
            <NavBar backTitle="返回结算"
                title={require('../../assets/img/m-analysis-title.png')}
                titleStyle={{ width: '1.73rem', height: '0.47rem' }}
                onBackClick={() => {
                    navigate(-1)
                }}
            />
            {
                !quiz.navigate && (
                    <div className="question">
                        <p className="title">{`${quiz.index + 1}. ${question.title}`}</p>
                        {
                            question.img.length > 0 && <img
                                className="question-img"
                                src={question.img}
                                onClick={(event) => {
                                    event.stopPropagation()
                                    setQuiz(produce(quiz, (draftState) => {
                                        draftState.image = question.img
                                        draftState.visible = true
                                    }))
                                }}
                            />
                        }
                        {
                            question.answer_list.map((item, index) => (
                                <QuizAnswerComponent key={index} question={question} item={item} index={index} allowClick={false} />
                            ))
                        }
                        {
                            !quiz.navigate && <AnalysisComponent question={question} />
                        }
                    </div>
                )
            }
            <ImageViewer
                image={quiz.image}
                visible={quiz.visible}
                onClose={() => {
                    setQuiz(produce(quiz, (draftState) => {
                        draftState.image = ''
                        draftState.visible = false
                    }))
                }}
            />
            {!quiz.navigate && <QuizBootom allowSubmit={false} />}
            {quiz.navigate && <QuizNavigateComponent />}
        </div>
    )

}
